import React, { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';

// Interfaces
interface RenderDialogProps {
    setShowDialog: React.Dispatch<React.SetStateAction<boolean>>
}
interface Props {
    readOnly: boolean
    buttonComponent: React.ReactElement
    renderDialog: (props: RenderDialogProps) => React.ReactNode;
}

const ButtonDialog: React.FC<Props> = ({ readOnly, buttonComponent, renderDialog }) => {

    const [showDialog, setShowDialog] = useState(false);


    return (
        <>
            <button onClick={() => setShowDialog(true)} disabled={readOnly}>
                {buttonComponent}
            </button>
            <Modal show={showDialog} setShowModal={setShowDialog}>
                {renderDialog({ setShowDialog })}
            </Modal>
        </>
    );
};

export default ButtonDialog;